// accounts/vm-view
import { useListIds } from 'src/hooks/use-list-table';
import { useListSearch } from 'src/hooks/use-list-search';
import { useItemsStore } from 'src/hooks/use-items-store';

import { getAccounts, getAccountById } from './data-view';

export const useItemsSearch = () => {
  return useListSearch();
};
export const useItemsIds = () => {
  return useListIds();
};

class AccountsApi {

  getItems(searchState) {
    return useItemsStore(searchState, getAccounts);
  }

  getDetail(payload, onSuccess) {
    getAccountById(payload).then((result) => {
      onSuccess(result);
    });
  }
}

export const accountsApi = new AccountsApi();
